import { apiRequest } from "../utils/apiClient";

export interface Role {
  role_id: string;
  name: string;
  permission_type?: string;
}

interface RoleListResponse {
  rows: Role[];
}

/**
 * Fetches all available roles.
 */
export const fetchRoles = async (): Promise<Role[]> => {
  try {
    const response = await apiRequest<RoleListResponse>(
      "/api/roles/list",
      "POST",
    );

    return response.data.rows ?? [];
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};